import { render, staticRenderFns } from "./card-files.vue?vue&type=template&id=fc025ab4&scoped=true"
import script from "./card-files.vue?vue&type=script&lang=js"
export * from "./card-files.vue?vue&type=script&lang=js"
import style0 from "./card-files.vue?vue&type=style&index=0&id=fc025ab4&prod&lang=css"
import style1 from "./card-files.vue?vue&type=style&index=1&id=fc025ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc025ab4",
  null
  
)

export default component.exports